export default __webpack_public_path__ + "static/media/logo192.610a11ee.png";